import { mount } from "svelte";

import TodosModal from "../modals/TodosModal/TodosModal.svelte";

export const bindTodosModal = () => {
  const target = document.getElementById("todos-modal");
  return mount(TodosModal, {
    target,
  });
};
